export const getItemModal = () => localStorage.getItem('itemModal')
export const setItemModal = () => localStorage.setItem('itemModal', 'true')

export const getCertificationModal = () => localStorage.getItem('certificationModal')
export const setCertificationModal = () => localStorage.setItem('certificationModal', 'true')